import { getSupabase } from "@/lib/supabaseClient";
import { getStableSession } from "@/lib/getStableSession";
import { fetchUserRole } from "@/lib/getUserRole";
import { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from "@/integrations/supabase/client";

export async function uploadViaEdge(file: File, productId: string) {
  const supabase = getSupabase();
  const session = await getStableSession(supabase);
  const role = session ? await fetchUserRole(supabase) : null;

  const reqId = crypto.randomUUID();
  const body = new FormData();
  body.append("productId", productId);
  body.append("file", file, file.name || "upload.bin");

  const url = `${SUPABASE_URL}/functions/v1/upload-product-image`;
  const bearer = session?.access_token || SUPABASE_PUBLISHABLE_KEY; // Phase A allows anon fallback

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "x-request-id": reqId,
      "authorization": `Bearer ${bearer}`,
      "apikey": SUPABASE_PUBLISHABLE_KEY,
    },
    body,
  });

  if (!res.ok) {
    let msg = `${res.status} ${res.statusText}`;
    try {
      const text = await res.text();
      if (text) msg = text.split("\n")[0];
    } catch {}
    throw new Error(msg);
  }

  const json = await res.json();
  console.log("edge upload ok", {
    reqId,
    hasJWT: !!session?.access_token,
    userId: session?.user?.id ?? null,
    role,
    ...json,
  });
  return json as { path: string; publicUrl?: string };
}